export type Unit = 'day' | 'month' | 'week' | 'year';

const dayOptions: number[] = [];

const monthOptions: number[] = [3, 6, 18, 24, 36];

const weekOptions: number[] = [2, 3, 5, 9, 21];

const yearOptions: number[] = [1, 2, 3, 5, 7];

export function getUnitOptions(unit: Unit): number[] {
  switch (unit) {
    case 'day':
      return dayOptions;
    case 'month':
      return monthOptions;
    case 'week':
      return weekOptions;
    case 'year':
      return yearOptions;
    default:
      return [];
  }
}
